const baseStyle = {
  color: 'orange.400',
};

export default { baseStyle };
